import React from 'react';

import BlogView from '@/modules/Blog/BlogView';

const Blog = () => {
  return <BlogView />;
};

export default Blog;
